import { motion } from "framer-motion";

export const Chapter = ({ id, num, title, children }) => (
  <section
    id={`chapter-${id}`}
    data-testid={`chapter-${id}`}
    className="scroll-mt-16 border-b border-sand/70 py-16 lg:scroll-mt-8 lg:py-24"
  >
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="flex items-baseline gap-4">
        <span className="font-serif text-4xl font-light italic text-gold/80 lg:text-5xl">{num}</span>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-graphite/45">Capítulo</p>
          <h2 className="mt-1 font-serif text-2xl tracking-tight text-jade sm:text-3xl lg:text-4xl">
            {title}
          </h2>
        </div>
      </div>
      <div className="mt-10 space-y-10">{children}</div>
    </motion.div>
  </section>
);

export const SubTitle = ({ children }) => (
  <h3 className="font-serif text-xl text-graphite sm:text-2xl">{children}</h3>
);

export const Body = ({ children, className = "" }) => (
  <p className={`max-w-3xl text-sm leading-relaxed text-graphite/75 sm:text-base ${className}`}>
    {children}
  </p>
);
